import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';


@Component({
  selector: 'echexpayment-view-invoice',
  templateUrl: './viewinvoice.component.html',
  styleUrls: ['./invoice.component.css']
})
export class ViewinvoiceComponent implements OnInit {

    busy: Subscription;
	public id: string;
	public token: string;
	public Plane_name: string;

    public data;
    public filterQuery = "";
    public rowsOnPage = 10;
    public sortBy = "date";
    public sortOrder = "asc";
	public invoice = <any>{};

	constructor(private router: Router, private route:ActivatedRoute, private toastr: ToastrService, private userService :UserService, private echexpaymentService :EchexpaymentService, private localStorageService: LocalstorageService) { 
	
	this.router = router;
	this.route = route;
	var currentUser = this.localStorageService.getData("currentUserToken");
	this.token =  currentUser.data.user_token;
	let userDetails = this.localStorageService.getData("currentUser");
	
	this.id = userDetails._id;

	}

	ngOnInit() {
		this.viewInvoice();
	}
	// view invoice 
	viewInvoice() {
		let userDetails = localStorage.getItem("currentUser");
		var userData = JSON.parse(userDetails);
		let params: any = this.route.snapshot.params;
		var data = {
		invoice_id:params.id,
		token:userData._id,
		user_token:this.token,
		_id:userData._id
		};
		let responseData = <any>{};
		this.busy = this.echexpaymentService.viewInvoice(data).subscribe(
			response => {
				responseData = response;
				this.invoice = responseData.data;
			},
			error => {
				responseData = error;
				this.toastr.error(responseData.error.message, 'Failed!');
			}
		);
	}
	// download invoice
	downloadInvoice(invoiceId)
	{
		let userDetails = localStorage.getItem("currentUser");
		var userData = JSON.parse(userDetails);
		let params: any = this.route.snapshot.params;
		var data = {
		invoice_id:params.id,
		token:userData._id,
		user_token:this.token,
		_id:userData._id
		};

		var googleWindow = window.open();
		this.busy = this.echexpaymentService.downloadInvoice(data).subscribe(
			(res) => {
				var file = new Blob([res], {type: "application/pdf"});
				var fileURL = URL.createObjectURL(file);
				googleWindow.location.replace(fileURL);
			}
		);
	}
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/invoice/viewinvoice.component.ts